<template>
  <div class="salary-bonus-edit">
    <el-card>
      <div class="header">
        <h2>ЗП + Премия (Год: {{ formData.academicYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="saveData" :loading="saving" v-if="formData.status !== 'APPROVED' && hasAccess(universityManagerRoles)">Сохранить</el-button>
        </div>
      </div>

      <div class="table-container" @paste="handlePaste" @keydown="handleKeydown">
        <table class="grid-table">
          <thead>
            <tr>
              <th>Наименование расходов</th>
              <th>Кол-во единиц по штату</th>
              <th>Кол-во единиц по факту</th>
              <th>ВСЕГО</th>
              <th>янв</th>
              <th>фев</th>
              <th>мар</th>
              <th>апр</th>
              <th>май</th>
              <th>июн</th>
              <th>июл</th>
              <th>авг</th>
              <th>сен</th>
              <th>окт</th>
              <th>ноя</th>
              <th>дек</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in formData.details" :key="item.uuid || item.type + (item.eduArea ? item.eduArea.id : '')" :class="{'group-row': isGroup(item.type), 'calculated-row': isCalculated(item.type) && item.type !== 'TEACHING_STAFF' && item.type !== 'BONUS_TEACHING_STAFF'}">
              <td class="title-cell" :style="getTitleStyle(item.type)">
                {{ getTitle(item) }}
                
                <div v-if="item.type === 'EXPENSES_JOB_PAYMENT' && formData.status !== 'APPROVED' && hasAccess(universityManagerRoles)" style="margin-top: 10px; display: flex; flex-wrap: wrap; gap: 5px; align-items: center;">
                  <el-select v-model="selectedSalaryItems" multiple collapse-tags placeholder="Выберите виды расходов" size="small" style="width: 250px;" filterable @change="onSalaryItemsChange($event, false)">
                    <el-option v-for="cat in standardSalaryItemsList" :key="cat.type" :label="cat.title" :value="cat.type" />
                  </el-select>
                </div>

                <div v-if="item.type === 'BONUS' && formData.status !== 'APPROVED' && hasAccess(universityManagerRoles)" style="margin-top: 10px; display: flex; flex-wrap: wrap; gap: 5px; align-items: center;">
                  <el-select v-model="selectedBonusItems" multiple collapse-tags placeholder="Выберите виды расходов" size="small" style="width: 250px;" filterable @change="onSalaryItemsChange($event, true)">
                    <el-option v-for="cat in standardBonusItemsList" :key="cat.type" :label="cat.title" :value="cat.type" />
                  </el-select>
                </div>

                <div v-if="item.type === 'TEACHING_STAFF' && formData.status !== 'APPROVED' && hasAccess(universityManagerRoles)" style="margin-top: 10px; display: flex; flex-wrap: wrap; gap: 5px; align-items: center;">
                  <el-select v-model="selectedEduAreas" multiple collapse-tags placeholder="Выберите факультеты" size="small" style="width: 250px;" filterable @change="onEduAreasChange($event, false)">
                    <el-option v-for="cat in allEduAreas" :key="cat.id" :label="cat.code === 'OTHER' ? cat.nameRu : (cat.code + ' - ' + cat.nameRu)" :value="cat.id" />
                  </el-select>
                </div>

                <div v-if="item.type === 'BONUS_TEACHING_STAFF' && formData.status !== 'APPROVED' && hasAccess(universityManagerRoles)" style="margin-top: 10px; display: flex; flex-wrap: wrap; gap: 5px; align-items: center;">
                  <el-select v-model="selectedBonusEduAreas" multiple collapse-tags placeholder="Выберите факультеты" size="small" style="width: 250px;" filterable @change="onEduAreasChange($event, true)">
                    <el-option v-for="cat in allEduAreas" :key="cat.id" :label="cat.code === 'OTHER' ? cat.nameRu : (cat.code + ' - ' + cat.nameRu)" :value="cat.id" />
                  </el-select>
                </div>


              </td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="0"><el-input v-model="item.staffCount" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatInputNumber(item.staffCount) || '0' }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="1"><el-input v-model="item.factCount" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatInputNumber(item.factCount) || '0' }}</td>
              
              <!-- Total -->
              <td v-if="!isGroup(item.type)" class="readonly-text" style="background-color: var(--el-fill-color-light); color: var(--el-text-color-regular);">{{ formatNumber(item.total) }}</td><td v-else class="readonly-text">{{ formatNumber(item.total) }}</td>
              
              <!-- Months -->
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="3"><el-input v-model="item.janSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.janSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="4"><el-input v-model="item.febSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.febSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="5"><el-input v-model="item.marSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.marSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="6"><el-input v-model="item.aprSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.aprSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="7"><el-input v-model="item.maySum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.maySum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="8"><el-input v-model="item.junSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.junSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="9"><el-input v-model="item.julSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.julSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="10"><el-input v-model="item.augSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.augSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="11"><el-input v-model="item.sepSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.sepSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="12"><el-input v-model="item.octSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.octSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="13"><el-input v-model="item.novSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.novSum) }}</td>
              <td v-if="!isGroup(item.type)" :data-item-idx="index" data-col="14"><el-input v-model="item.decSum" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate" /></td><td v-else class="readonly-text">{{ formatNumber(item.decSum) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import expensesSalaryBonusService from '@/services/expensesSalaryBonusService';
import authService from '@/services/authService';
import professionEduAreaService from '@/services/professionEduAreaService';
import {handleGridKeydown} from "@/utils/gridKeyboardNav";

export default defineComponent({
  name: 'ExpensesSalaryBonusEditView',
  setup() {
    const route = useRoute();
    const router = useRouter();
    const saving = ref(false);
    const formData = ref({
      uuid: '',
      academicYear: null,
      status: '',
      details: [] as any[]
    });

    const allEduAreas = ref<any[]>([]);
    const selectedEduAreas = ref<number[]>([]);
    const selectedBonusEduAreas = ref<number[]>([]);
    
    const selectedSalaryItems = ref<string[]>([]);
    const selectedBonusItems = ref<string[]>([]);

    const loadDictionaries = async () => {
      try {
        const data = await professionEduAreaService.getAllList();
        allEduAreas.value = data || [];
        allEduAreas.value.push({ id: -1, code: 'OTHER', nameRu: 'Прочие факультеты не идентифицируемые напрямую с областью образования' });
      } catch (error) {
        ElMessage.error('Ошибка при загрузке справочников');
      }
    };

    const standardSalaryItemsList = [
      { type: 'ADMIN_PERSONNEL', title: 'Административно-управленческий персонал' },
      { type: 'TEACHING_STAFF', title: 'Профессорско-преподавательский состав (профессора, доценты, старшие преподаватели, преподаватели, кураторы, координаторы и пр)' },
      { type: 'SUPPORT_STAFF', title: 'Учебно-вспомогательный персонал' },
      { type: 'MAINTENANCE_STAFF', title: 'Обслуживающий и прочий персонал' }
    ];

    const standardBonusItemsList = [
      { type: 'BONUS_ADMIN_PERSONNEL', title: 'Административно-управленческий персонал' },
      { type: 'BONUS_TEACHING_STAFF', title: 'Профессорско-преподавательский состав (профессора, доценты, старшие преподаватели, преподаватели, кураторы, координаторы и пр)' },
      { type: 'BONUS_SUPPORT_STAFF', title: 'Учебно-вспомогательный персонал' },
      { type: 'BONUS_MAINTENANCE_STAFF', title: 'Обслуживающий и прочий персонал' }
    ];



    const universityManagerRoles: string[] = authService.getUniversityManagerRoles();

    const hasAccess = (...roleGroups: string[][]) => {
      const allRoles = roleGroups.flat();
      return authService.hasAccess(allRoles);
    };

    const typeDictionary: any = {
      SALARY: { title: "ЗАРАБОТНАЯ ПЛАТА", group: true, indent: 0, parent: null },
      EXPENSES_JOB_PAYMENT: { title: "Расходы на оплату труда", group: true, indent: 1, parent: 'SALARY' },
      ADMIN_PERSONNEL: { title: "Административной управленческий персонал (ректор, проректор, кадры, юрист, экономист, бухгалтер, секретарь, переводчик, архив и пр.)", group: false, indent: 2, parent: 'EXPENSES_JOB_PAYMENT' },
      TEACHING_STAFF: { title: "Профессорско-преподавательский состав (профессора, доценты, старшие преподаватели, преподаватели, кураторы, координаторы и пр)", group: true, indent: 2, parent: 'EXPENSES_JOB_PAYMENT' },
      EDU_AREA_ITEM: { title: "Факультет (отделение) по области образования (динамический)", group: false, indent: 3, parent: 'TEACHING_STAFF' },
      OTHER_FACULTIES: { title: "Прочие факультеты не идентифицируемые напряму со областью образования", group: false, indent: 3, parent: 'TEACHING_STAFF' },
      SUPPORT_STAFF: { title: "Учебно-вспомогательный персонал (библиотекарь, сис.админ., лаборант и пр.)", group: false, indent: 2, parent: 'EXPENSES_JOB_PAYMENT' },
      MAINTENANCE_STAFF: { title: "Обслуживающий и прочий персонал (зав.хоз, водитель, энергетик, электрик, сантехник, слесарь, плотник, дворник, уборщик, разнорабочий и пр.)", group: false, indent: 2, parent: 'EXPENSES_JOB_PAYMENT' },
      
      BONUS: { title: "Дополнительные расходы по оплате труда (премии)", group: true, indent: 1, parent: 'SALARY' },
      BONUS_ADMIN_PERSONNEL: { title: "Административной управленческий персонал", group: false, indent: 2, parent: 'BONUS' },
      BONUS_TEACHING_STAFF: { title: "Профессорско-преподавательский состав (профессора, доценты, старшие преподаватели, преподаватели, кураторы, координаторы и пр)", group: true, indent: 2, parent: 'BONUS' },
      BONUS_EDU_AREA_ITEM: { title: "Факультет (отделение) по области образования (динамический)", group: false, indent: 3, parent: 'BONUS_TEACHING_STAFF' },
      BONUS_OTHER_FACULTIES: { title: "Прочие факультеты не идентифицируемые напряму со областью образования", group: false, indent: 3, parent: 'BONUS_TEACHING_STAFF' },
      BONUS_SUPPORT_STAFF: { title: "Учебно-вспомогательный персонал (библиотекарь, сис.админ., лаборант и пр.)", group: false, indent: 2, parent: 'BONUS' },
      BONUS_MAINTENANCE_STAFF: { title: "Обслуживающий и прочий персонал (зав.хоз, водитель, энергетик, электрик, сантехник, слесарь, плотник, дворник, уборщик, разнорабочий и пр.)", group: false, indent: 2, parent: 'BONUS' },
    };

    const getTitle = (item: any) => {
      if (item.type === 'EDU_AREA_ITEM' || item.type === 'BONUS_EDU_AREA_ITEM') {
        if (item.eduArea) {
          return `Факультет (отделение) по области образования ${item.eduArea.code} - ${item.eduArea.nameRu}`;
        }
        return typeDictionary[item.type]?.title || item.type;
      }
      return typeDictionary[item.type]?.title || item.type;
    };
    const isGroup = (type: string) => typeDictionary[type]?.group || false;
    const isCalculated = (type: string) => typeDictionary[type]?.group || false;
    const getTitleStyle = (type: string) => {
      const indent = typeDictionary[type]?.indent || 0;
      return { paddingLeft: `${indent * 20 + 8}px`, fontWeight: typeDictionary[type]?.group ? 'bold' : 'normal' };
    };

    const recalculate = () => {
      if (!formData.value.details || formData.value.details.length === 0) return;
      const allDetails = formData.value.details;
      const rootDetails = allDetails.filter((d: any) => !typeDictionary[d.type]?.parent);
      const months = ['janSum', 'febSum', 'marSum', 'aprSum', 'maySum', 'junSum', 'julSum', 'augSum', 'sepSum', 'octSum', 'novSum', 'decSum'];

      // First calculate totals for input fields
      allDetails.forEach((item: any) => {
        if (!isCalculated(item.type)) {
          item.total = months.reduce((acc, month) => acc + parseFloat(item[month] || 0), 0);
        }
      });

      const calculateNodeSums = (parentDetail: any) => {
        if (!isCalculated(parentDetail.type)) return;
        
        const children = allDetails.filter((d: any) => typeDictionary[d.type]?.parent === parentDetail.type);
        
        parentDetail.staffCount = 0;
        parentDetail.factCount = 0;
        parentDetail.total = 0;
        months.forEach((m: string) => parentDetail[m] = 0);
        
        children.forEach((child: any) => {
           calculateNodeSums(child);
           
           parentDetail.staffCount += parseFloat(child.staffCount || 0);
           parentDetail.factCount += parseFloat(child.factCount || 0);
           parentDetail.total += parseFloat(child.total || 0);
           months.forEach((m: string) => parentDetail[m] += parseFloat(child[m] || 0));
        });
      };

      rootDetails.forEach((root: any) => calculateNodeSums(root));
    };

    const sortDetails = () => {
      const orderMap: any = {
        SALARY: 100,
        EXPENSES_JOB_PAYMENT: 110,
        ADMIN_PERSONNEL: 120,
        TEACHING_STAFF: 130,
        EDU_AREA_ITEM: 131,
        OTHER_FACULTIES: 132,
        SUPPORT_STAFF: 140,
        MAINTENANCE_STAFF: 150,

        BONUS: 200,
        BONUS_ADMIN_PERSONNEL: 220,
        BONUS_TEACHING_STAFF: 230,
        BONUS_EDU_AREA_ITEM: 231,
        BONUS_OTHER_FACULTIES: 232,
        BONUS_SUPPORT_STAFF: 240,
        BONUS_MAINTENANCE_STAFF: 250
      };

      formData.value.details.sort((a: any, b: any) => {
        const orderA = orderMap[a.type] || 999;
        const orderB = orderMap[b.type] || 999;
        if (orderA !== orderB) return orderA - orderB;
        if (a.eduArea && b.eduArea) {
           return (a.eduArea.code || '').localeCompare(b.eduArea.code || '');
        }
        return 0;
      });
      formData.value.details.forEach((d: any, index: number) => { d.itemOrder = index + 1; });
    };

    const onSalaryItemsChange = (newVal: string[], isBonus: boolean) => {
       const stdList = isBonus ? standardBonusItemsList : standardSalaryItemsList;
       const parentType = isBonus ? 'BONUS' : 'EXPENSES_JOB_PAYMENT';
       
       // 1. Remove unchecked
       const currentItems = formData.value.details.filter((d: any) => stdList.some((s: any) => s.type === d.type));
       currentItems.forEach((item: any) => {
          if (!newVal.includes(item.type)) {
             formData.value.details = formData.value.details.filter((d: any) => d !== item);
             formData.value.details = formData.value.details.filter((d: any) => typeDictionary[d.type]?.parent !== item.type);
             
             if (item.type === 'TEACHING_STAFF') {
                 selectedEduAreas.value = [];
             } else if (item.type === 'BONUS_TEACHING_STAFF') {
                 selectedBonusEduAreas.value = [];
             }
          }
       });

       // 2. Add checked
       newVal.forEach(type => {
          const exists = formData.value.details.some((d: any) => d.type === type);
          if (!exists) {
            const newRow = {
              uuid: null,
              type: type,
              eduArea: null,
              itemOrder: 999, staffCount: '', factCount: '', total: '',
              janSum: '', febSum: '', marSum: '', aprSum: '', maySum: '', junSum: '',
              julSum: '', augSum: '', sepSum: '', octSum: '', novSum: '', decSum: '',
              isCalculated: typeDictionary[type]?.group || false
            };
            
            formData.value.details.push(newRow);
          }
       });

       sortDetails();
       recalculate();
    };

    const onEduAreasChange = (newVal: number[], isBonus: boolean) => {
      const targetType = isBonus ? 'BONUS_EDU_AREA_ITEM' : 'EDU_AREA_ITEM';
      const otherType = isBonus ? 'BONUS_OTHER_FACULTIES' : 'OTHER_FACULTIES';
      const parentType = isBonus ? 'BONUS_TEACHING_STAFF' : 'TEACHING_STAFF';

      // 1. Remove unchecked
      const currentItems = formData.value.details.filter((d: any) => 
         (d.type === targetType && d.eduArea) || d.type === otherType
      );
      
      currentItems.forEach((item: any) => {
         const id = item.type === otherType ? -1 : item.eduArea.id;
         if (!newVal.includes(id)) {
            formData.value.details = formData.value.details.filter((d: any) => d !== item);
         }
      });

      // 2. Add checked
      newVal.forEach(id => {
         const exists = formData.value.details.some((d: any) => 
            (id === -1 && d.type === otherType) || 
            (d.type === targetType && d.eduArea && d.eduArea.id === id)
         );
         
         if (!exists) {
            const area = allEduAreas.value.find(a => a.id === id);
            if (!area) return;
            const newRow = {
              uuid: null,
              type: id === -1 ? otherType : targetType,
              eduArea: id === -1 ? null : { id: area.id, code: area.code, nameRu: area.nameRu },
              itemOrder: 999, staffCount: '', factCount: '', total: '',
              janSum: '', febSum: '', marSum: '', aprSum: '', maySum: '', junSum: '',
              julSum: '', augSum: '', sepSum: '', octSum: '', novSum: '', decSum: '',
              isCalculated: false
            };
            
            formData.value.details.push(newRow);
         }
      });
      
      sortDetails();
      recalculate();
    };

    const loadData = async () => {
      const uuid = route.params.uuid as string;
      if (!uuid) return;
      
      try {
        const data = await expensesSalaryBonusService.getById(uuid);
        
        // Filter out types not explicitly supported by this view (e.g. COMPENSATION_COST)
        if (data && data.details) {
            data.details = data.details.filter((d: any) => typeDictionary[d.type] !== undefined);
        }
        
        formData.value = data;
        
        // Sync refs
        selectedSalaryItems.value = data.details
            .filter((d: any) => standardSalaryItemsList.some(s => s.type === d.type))
            .map((d: any) => d.type);
        selectedBonusItems.value = data.details
            .filter((d: any) => standardBonusItemsList.some(s => s.type === d.type))
            .map((d: any) => d.type);
            
        selectedEduAreas.value = data.details
            .filter((d: any) => d.type === 'EDU_AREA_ITEM' && d.eduArea)
            .map((d: any) => d.eduArea.id);
        if (data.details.some((d: any) => d.type === 'OTHER_FACULTIES')) selectedEduAreas.value.push(-1);
        
        selectedBonusEduAreas.value = data.details
            .filter((d: any) => d.type === 'BONUS_EDU_AREA_ITEM' && d.eduArea)
            .map((d: any) => d.eduArea.id);
        if (data.details.some((d: any) => d.type === 'BONUS_OTHER_FACULTIES')) selectedBonusEduAreas.value.push(-1);

        sortDetails();
        recalculate();
      } catch (error) {
        ElMessage.error('Ошибка загрузки документа');
      }
    };

    const saveData = async () => {
      saving.value = true;
      try {
        recalculate();
        
        const payload = {
          totalPlanSum: formData.value.details.filter((d: any) => !typeDictionary[d.type]?.parent).reduce((sum, item) => sum + parseFloat(item.total || 0), 0),
          details: formData.value.details
        };
        await expensesSalaryBonusService.update(formData.value.uuid, payload);
        ElMessage.success('Данные успешно сохранены');
        loadData();
      } catch (error) {
        ElMessage.error('Ошибка при сохранении данных');
      } finally {
        saving.value = false;
      }
    };

    const goBack = () => {
      router.push('/expenses/salary-bonus');
    };

    const handleKeydown = (event: any) => {
      handleGridKeydown(event, document.querySelector('.salary-bonus-edit'));
    };

    const handlePaste = (event: any) => {
      const target = event.target;
      if (!target || target.tagName !== 'INPUT') return;

      const td = target.closest('td');
      if (!td) return;

      const startItemIdx = parseInt(td.dataset.itemIdx);
      const startCol = parseInt(td.dataset.col);

      if (isNaN(startItemIdx) || isNaN(startCol)) return;

      const clipboardData = event.clipboardData || (window as any).clipboardData;
      if (!clipboardData) return;

      const text = clipboardData.getData('text/plain');
      if (!text) return;

      const rows = text.split(/\r?\n/).filter((r: string) => r.trim() !== '');
      if (rows.length <= 1 && !rows[0].includes('\t')) return;

      event.preventDefault();

      const COL_FIELDS = [
        'staffCount', 'factCount', 'SKIP',
        'janSum', 'febSum', 'marSum', 'aprSum', 'maySum', 'junSum',
        'julSum', 'augSum', 'sepSum', 'octSum', 'novSum', 'decSum'
      ];

      let currentItemIdx = startItemIdx;

      for (let r = 0; r < rows.length; r++) {
        const cols = rows[r].split('\t');
        
        // Skip group rows
        while (currentItemIdx < formData.value.details.length && isGroup(formData.value.details[currentItemIdx].type)) {
           currentItemIdx++;
        }

        if (currentItemIdx >= formData.value.details.length) break;
        let currentItem = formData.value.details[currentItemIdx];

        for (let c = 0; c < cols.length; c++) {
          const colIdx = startCol + c;
          if (colIdx >= COL_FIELDS.length) break;

          const field = COL_FIELDS[colIdx];
          if (field === 'SKIP') continue;

          const rawVal = String(cols[c]).replace(/\s/g, '').replace(',', '.');
          
          const num = parseFloat(rawVal);
          currentItem[field] = isNaN(num) || num === 0 ? '' : num;
        }

        currentItemIdx++;
      }

      recalculate();
    };

    const formatNumber = (val: any) => {
      if (val === undefined || val === null || val === '' || isNaN(val as number)) return '0,00';
      const formatted = parseFloat(val).toFixed(2);
      const parts = formatted.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    };

    const formatInputNumber = (value: any) => {
      if (value === undefined || value === null || value === '') return '';
      const parts = value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    };

    const parseInputNumber = (value: any) => {
      if (!value) return '';
      let parsed = value.toString().replace(',', '.');
      parsed = parsed.replace(/[^\d.]/g, '');
      const parts = parsed.split('.');
      if (parts.length > 2) {
        parsed = parts[0] + '.' + parts.slice(1).join('');
      }
      return parsed;
    };

    onMounted(() => {
      loadDictionaries();
      loadData();
    });

    return {
      formData,
      saving,
      getTitle,
      isGroup,
      isCalculated,
      getTitleStyle,
      recalculate,
      saveData,
      goBack,
      hasAccess,
      universityManagerRoles,
      allEduAreas,
      standardSalaryItemsList,
      standardBonusItemsList,
      selectedEduAreas,
      selectedBonusEduAreas,
      selectedSalaryItems,
      selectedBonusItems,
      onSalaryItemsChange,
      onEduAreasChange,
      formatNumber,
      formatInputNumber,
      parseInputNumber,
      handleKeydown,
      handlePaste
    };
  }
});
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.table-container {
  overflow-x: auto;
}

.grid-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

.grid-table th, .grid-table td {
  border: 1px solid #ebeef5;
  padding: 8px;
  text-align: left;
  vertical-align: middle;
}

.grid-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: bold;
  font-size: 13px;
}

.grid-table td {
  font-size: 13px;
}

.title-cell {
  min-width: 200px;
  max-width: 350px;
}

.group-row {
  background-color: #f9f9f9;
}

.calculated-row {
  background-color: #e8f5e9 !important;
}

.readonly-text {
  text-align: right;
  padding-right: 10px !important;
  font-weight: bold;
}

:deep(.el-input__wrapper) {
  padding: 0 5px;
}
:deep(.el-input__inner) {
  text-align: right;
  font-size: 13px;
}
</style>
